var map = {
	"./cheer.mp3": 1651,
	"./correct-answer.mp3": 5246,
	"./forbidden.mp3": 6551,
	"./hey.mp3": 3580,
	"./konami.mp3": 6463,
	"./mouse-over.mp3": 8,
	"./next.mp3": 588,
	"./swish.mp3": 8287,
	"./wrong-answer.mp3": 6075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1561;